import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import {getCognitoConfig} from './config/authConfig.ts';
import {saveTokens} from './utils/authStorage.ts';
import {DEV_AUTH_BYPASS} from './lib/auth/devBypass.ts';

async function handleCallback() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');

  if (!code || !window.location.pathname.startsWith('/callback')) return;
  if (DEV_AUTH_BYPASS) return;

  try {
    const config = await getCognitoConfig();
    const tokenEndpoint = `https://${config.domain}.auth.${config.region}.amazoncognito.com/oauth2/token`;
    const redirectUri = `${window.location.origin}/callback`;

    const body = new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: config.clientId,
      code,
      redirect_uri: redirectUri,
    });

    const response = await fetch(tokenEndpoint, {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: body.toString(),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Token exchange failed: ${errorText}`);
    }

    const tokens = await response.json();

    if (tokens.id_token && tokens.access_token) {
      saveTokens(tokens.id_token, tokens.access_token, tokens.refresh_token);
      // Defer navigation so the writes flush before unmount.
      setTimeout(() => window.location.replace('/'), 0);
    } else {
      throw new Error('No tokens received from Cognito');
    }
  } catch (err) {
    console.error('Callback handling error:', err);
    window.location.replace('/');
  }
}

async function bootstrap() {
  await handleCallback();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();
